import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const NAMES = ['Juan', 'María', 'Carlos', 'Ana', 'Pedro', 'Sofía', 'Diego', 'Valentina', 'Andrés', 'Camila', 'Lucía', 'Martín', 'Florencia', 'Javier'];
const COUNTRIES = ['Argentina', 'México', 'Colombia', 'Chile', 'España', 'Perú', 'Ecuador', 'Uruguay', 'Costa Rica', 'Panamá'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    country: ''
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setCurrentData({
        name: randomName,
        country: randomCountry
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Stay visible for 4 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(triggerPopup, 5000);
    // Recurring interval (every 12 seconds)
    const interval = setInterval(triggerPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-163">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white border-2 border-black rounded-lg shadow-xl p-4 max-w-sm flex items-center gap-4" data-id="element-164">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-165">
            <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-166" />
          </div>
          <div data-id="element-167">
            <p className="text-sm md:text-base font-bold text-gray-900 leading-tight" data-id="element-168">
              {currentData.name} de {currentData.country}
            </p>
            <p className="text-xs md:text-sm text-gray-600" data-id="element-169">
              acaba de comprar este sistema
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}